import { useEffect, useState } from "react";
import { toast } from "sonner";
import { staffApi } from "./staffApi";
import { TONES, playTone, canVibrate, doVibrate } from "./alerts";

export const AlertPrefs = ({ onClose }) => {
  const [prefs, setPrefs] = useState(null);
  const vib = canVibrate();

  useEffect(() => {
    staffApi.get("/staff/me/alert-prefs").then((r) => setPrefs(r.data)).catch(() => setPrefs({ sound_on: true, sound_id: 3, vibrate_on: false }));
  }, []);

  const save = (next) => {
    setPrefs(next);
    staffApi.post("/staff/me/alert-prefs", next).then(() => toast.success("Saved — follows your PIN to any device")).catch(() => toast.error("Could not save"));
  };

  if (!prefs) return null;
  return (
    <div data-testid="alert-prefs-modal" className="fixed inset-0 z-[80] bg-black/75 flex items-start justify-center overflow-y-auto p-4" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-md bg-[#141419] rounded-3xl border border-[#D4AF37]/40 p-5 my-6">
        <div className="flex items-center justify-between">
          <p className="text-xs font-black tracking-[0.25em] text-[#D4AF37]">MY ALERTS — TIED TO YOUR PIN</p>
          <button data-testid="alert-prefs-close" onClick={onClose} className="w-8 h-8 rounded-full border border-white/20 text-white/60">✕</button>
        </div>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-sm font-bold">Sound</span>
          <button data-testid="alert-sound-toggle" onClick={() => save({ ...prefs, sound_on: !prefs.sound_on })}
            className={`rounded-full px-4 py-2 text-xs font-black border ${prefs.sound_on ? "bg-[#2ECC71] text-black border-[#2ECC71]" : "border-white/25 text-white/50"}`}>
            {prefs.sound_on ? "ON" : "OFF"}
          </button>
        </div>
        <div className={`mt-3 space-y-1.5 ${prefs.sound_on ? "" : "opacity-40 pointer-events-none"}`}>
          {TONES.map((t) => (
            <div key={t.id} className={`flex items-center gap-2 rounded-xl border px-3 py-2 ${prefs.sound_id === t.id ? "border-[#D4AF37] bg-[#D4AF37]/10" : "border-white/10"}`}>
              <button data-testid={`alert-tone-pick-${t.id}`} onClick={() => save({ ...prefs, sound_id: t.id })} className="flex-1 text-left">
                <span className="text-sm font-bold">{t.id}. {t.name}</span>
                <span className="text-[10px] text-white/40 font-bold ml-2">{t.id <= 3 ? "quiet afternoon" : t.id >= 8 ? "full Friday" : ""}</span>
              </button>
              <button data-testid={`alert-tone-test-${t.id}`} onClick={() => playTone(t.id)} aria-label={`Test ${t.name}`}
                className="shrink-0 w-9 h-9 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] text-sm font-black">▶</button>
            </div>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between">
          <div>
            <span className="text-sm font-bold">Vibrate</span>
            {!vib && <p data-testid="alert-vibrate-unsupported" className="text-[11px] text-white/45 mt-0.5">Not supported on this device — iPhones and iPads block vibration in the browser.</p>}
          </div>
          {vib ? (
            <button data-testid="alert-vibrate-toggle" onClick={() => { const n = { ...prefs, vibrate_on: !prefs.vibrate_on }; save(n); if (n.vibrate_on) doVibrate(); }}
              className={`rounded-full px-4 py-2 text-xs font-black border ${prefs.vibrate_on ? "bg-[#2ECC71] text-black border-[#2ECC71]" : "border-white/25 text-white/50"}`}>
              {prefs.vibrate_on ? "ON" : "OFF"}
            </button>
          ) : (
            <span className="rounded-full px-4 py-2 text-xs font-black border border-white/10 text-white/25">N/A</span>
          )}
        </div>
        <p className="mt-3 text-[11px] text-white/40">Sound and vibrate are independent — either, neither, or both. Your choice follows your PIN to whichever tablet or phone you pick up.</p>
      </div>
    </div>
  );
};
